import { Component } from "@angular/core";
import { Title } from "@angular/platform-browser";
import {
    ActivatedRoute,
    NavigationEnd,
    Router,
    RouterOutlet
} from "@angular/router";
import { filter, map, mergeMap } from "rxjs/operators";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.css"],
    standalone: true,
    imports: [RouterOutlet]
})
export class AppComponent {
    title = "app";

    constructor(
        private _router: Router,
        private _route: ActivatedRoute,
        private _title: Title
    ) {
        this._router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                map((_) => this._route),
                map((route) => {
                    while (route.firstChild) {
                        route = route.firstChild;
                    }

                    return route;
                }),
                mergeMap((route) => route.data),
                map((data) => data["title"])
            )
            .subscribe((title) => {
                this._title.setTitle(title ? title : "InSIght by ISI");
            });
    }
}
